import React, { Component } from 'react';
class Header extends Component {
  render() {
    return(         
<div className="row">
<div className="col-md-12 col-xs-12 heading">
<h1>Critical Illness Insurance Calculator</h1>
<p>Adjust the sliders to estimate the coverage amount you may need.</p>
</div>
 </div>
    )
  }
}

export default Header;